var map = {
	"./alert.svg": "49bb",
	"./error-vector.svg": "c582",
	"./happy-emoji.svg": "75f0",
	"./logo-db1.svg": "038a",
	"./logo-gestão-pessoas-mobile.svg": "c5d5",
	"./logo-gestão-pessoas.svg": "3b40",
	"./logo.svg": "e347",
	"./maintenance_vector.svg": "ee08",
	"./neutral-emoji.svg": "10e0",
	"./not_found_vector.svg": "65b2",
	"./reviewed-docs-vector.svg": "1a67",
	"./sad-emoji.svg": "4cb8",
	"./update-icon.svg": "c19b",
	"./very-happy-emoji.svg": "d177",
	"./very-sad-emoji.svg": "0e70"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";